import { render, staticRenderFns } from "./domain__list.vue?vue&type=template&id=ed8deb7c"
import script from "./domain__list.vue?vue&type=script&lang=js"
export * from "./domain__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports